export default __webpack_public_path__ + "static/media/img2.484d370d.jpg";